import MathChallenge from "../images/challenges/math_challenges.webp";
import AlgorithmChallenge from "../images/challenges/algorithm_challenges.webp";
import {Challenge, ChallengeItem, AnswerType} from "../models/Challenge";
import {TAGS} from "../components/generic/BCTag";

export const CHALLENGES_TYPES_CONFIG = [
    new Challenge(
        "mathematical-challenges",
        "Mathematical Programming Challenges",
        "Solve mathematical problems using programming techniques",
        MathChallenge,
        "mathematicalChallenges",
        false,
        false,
        [
            new ChallengeItem(
                "weekend-numbers",
                "Weekend Numbers",
                "A 'weekend number' is one where the sum of its digits equals 6 or 7 (like Saturday and Sunday).\nExamples: 15 (1+5=6), 16 (1+6=7), 42 (4+2=6), 25 (2+5=7).",
                "Find numbers where digit sum equals 6 or 7",
                "Find the sum of all weekend numbers less than 5000.",
                [TAGS.EASY],
                undefined,
                undefined,
                [
                    "Start by writing a function to calculate the sum of digits for any number",
                    "Check each number from 1 to 4999 and test if its digit sum is 6 or 7",
                    "Keep a running total of all numbers that meet the weekend criteria"
                ],
                "296630",
                AnswerType.NUMBER
            ),
                new ChallengeItem(
                    "corner-digits",
                    "Corner Digits",
                    "The 'corner digits' of a number are its first and last digits.\nFor 3847, the corner digits are 3 and 7, with sum 10.\nFor 92, corner digits are 9 and 2, sum 11.\nFor 5, the sum is 5+5=10.",
                    "Sum of first and last digits",
                    "Find the sum of all corner digit sums for integers from 1 to 20000.",
                    [TAGS.EASY],
                    undefined,
                    undefined,
                    [
                            "Extract the first digit by repeatedly dividing by 10, or convert to string",
                            "The last digit is simply n % 10",
                            "Single digit numbers use the same digit twice"
                    ],
                    "149997",
                    AnswerType.NUMBER
                ),
            new ChallengeItem(
                "first-digit-match",
                "First Digit Match",
                "The number 525 starts with 5 and ends with 5 - the first and last digits match.\nThe number 1231 starts with 1 and ends with 1.\nSingle digit numbers like 7 also count.",
                "Count numbers with matching first and last digits",
                "How many positive integers less than 100000 have matching first and last digits?",
                [TAGS.EASY],
                undefined,
                undefined,
                [
                    "Convert numbers to strings to easily access first and last characters",
                    "Remember that single-digit numbers count as having matching first and last digits",
                    "Think about the pattern: 1-9, 11, 22, ..., 99, 101, 111, ..."
                ],
                "10008",
                AnswerType.NUMBER
            ),
            new ChallengeItem(
                "double-square",
                "Double Square",
                "A 'double square' is a number that becomes a perfect square when doubled.\nFor example, 8 is a double square because 2×8 = 16 = 4².\nAlso, 18 is a double square: 2×18 = 36 = 6².",
                "Numbers that become perfect squares when doubled",
                "Find the sum of all double squares less than 10000.",
                [TAGS.EASY],
                undefined,
                undefined,
                [
                    "A number n is a double square if 2n is a perfect square",
                    "Use Math.sqrt() and check if the result is an integer",
                    "Double squares follow the pattern: n = k²/2 where k is even"
                ],
                "233590",
                AnswerType.NUMBER
            ),
                new ChallengeItem(
                    "staircase-numbers",
                    "Staircase Numbers",
                    "A 'staircase number' has each digit exactly one more than the previous digit.\nExamples: 123, 456, 789, 3456, 12345.\nSingle digits don't count as staircase numbers.",
                    "Numbers with consecutive ascending digits",
                    "Find the sum of all staircase numbers less than 100000.",
                    [TAGS.EASY],
                    undefined,
                    undefined,
                    [
                            "Each digit must be exactly 1 more than the previous digit",
                            "Valid staircase numbers: 12, 23, ..., 89, 123, 234, ..., 789, etc.",
                            "The longest possible is 123456789"
                    ],
                    "200500",
                    AnswerType.NUMBER
                ),
            new ChallengeItem(
                "ascending-product",
                "Ascending Product",
                "For a number with ascending digits (like 1234), find the product of its digits.\nFor 1234: 1×2×3×4 = 24. For 123: 1×2×3 = 6.\nSingle digit numbers have a product equal to themselves.",
                "Product of digits for numbers with ascending digits",
                "Find the sum of the digit products of all numbers from 1 to 999 that have strictly ascending digits.",
                [TAGS.EASY],
                undefined,
                undefined,
                [
                    "First identify numbers with strictly ascending digits (each digit must be greater than the previous)",
                    "For each valid number, multiply all its digits together",
                    "Examples of ascending numbers: 1, 2, ..., 9, 12, 13, ..., 89, 123, ..., 789"
                ],
                "10365",
                AnswerType.NUMBER
            ),
            new ChallengeItem(
                "five-factor",
                "Five Factor",
                "A number has a 'five factor' equal to how many times 5 divides it evenly.\n25 has five factor 2 (25÷5=5, 5÷5=1).\n125 has five factor 3. Numbers not divisible by 5 have five factor 0.",
                "Count how many times 5 divides into numbers",
                "Find the sum of the five factors of all integers from 1 to 50000.",
                [TAGS.EASY],
                undefined,
                undefined,
                [
                    "Keep dividing by 5 until the number is no longer divisible by 5",
                    "Count how many times you can divide - that's the five factor",
                    "Numbers like 25, 125, 625 have higher five factors"
                ],
                "12499",
                AnswerType.NUMBER
            ),
                new ChallengeItem(
                    "happy-ending",
                    "Happy Ending",
                    "A number has a 'happy ending' if its last two digits form a perfect square (01, 04, 09, 16, 25, 36, 49, 64, 81, 00). Examples: 316, 1225, 1849 all have happy endings.",
                    "Count numbers ending in perfect squares",
                    "How many integers from 100 to 99999 have happy endings?",
                    [TAGS.EASY],
                    undefined,
                    undefined,
                    [
                            "The last two digits are n % 100",
                            "Check if this value is in the set {0, 1, 4, 9, 16, 25, 36, 49, 64, 81}",
                            "00 counts as 0, which is a perfect square"
                    ],
                    "9990",
                    AnswerType.NUMBER
                ),

            new ChallengeItem(
                "twin-digit-count",
                "Twin Digit Count",
                "A number has 'twin digits' when two adjacent digits are the same.\n1223 has twin digits (22). 1000 has twin digits (00).\n12321 doesn't have twin digits.",
                "Count numbers with adjacent identical digits",
                "How many integers from 10 to 99999 contain at least one pair of twin digits?",
                [TAGS.EASY],
                undefined,
                undefined,
                [
                    "Check each pair of adjacent digits in the number",
                    "Convert to string to easily compare adjacent characters",
                    "If any adjacent pair matches, the number has twin digits"
                ],
                "33570",
                AnswerType.NUMBER
            ),
            new ChallengeItem(
                "mod-seven-sum",
                "Mod Seven Sum",
                "When 15 is divided by 7, the remainder is 1.\nWhen 23 is divided by 7, the remainder is 2.\nNumbers with remainder 0 when divided by 7 are multiples of 7.",
                "Sum numbers with specific remainder when divided by 7",
                "Find the sum of all positive integers less than 10000 that have remainder 4 when divided by 7.",
                [TAGS.EASY],
                undefined,
                undefined,
                [
                    "Use the modulo operator (%) to find remainders",
                    "Numbers with remainder 4 are: 4, 11, 18, 25, ...",
                    "This forms an arithmetic sequence"
                ],
                "7137858",
                AnswerType.NUMBER
            ),
                new ChallengeItem(
                    "dozen-multiple",
                    "Dozen Multiple",
                    "A 'dozen multiple' is divisible by 12.\nThese include 12, 24, 36, 48, 60, etc.\nThey must be divisible by both 3 and 4.",
                    "Sum squares of multiples of 12",
                    "Find the sum of the squares of all dozen multiples less than 500.",
                    [TAGS.EASY],
                    undefined,
                    undefined,
                    [
                            "Generate multiples of 12: 12, 24, 36, ..., 492",
                            "Square each multiple and sum them",
                            "Be careful not to exceed 500"
                    ],
                    "3430224",
                    AnswerType.NUMBER
                ),
                new ChallengeItem(
                    "bookend-zeros",
                    "Bookend Zeros",
                    "A number has 'bookend zeros' if it starts and ends with 0 (when written with leading zeros for comparison).\nIn the range 1-999, we consider 1 as 001, 50 as 050, etc.\nSo 101 would NOT have bookend zeros, but 100 would (as 100).",
                    "Count numbers ending with zero",
                    "How many integers from 100 to 9999 end with the digit 0?",
                    [TAGS.EASY],
                    undefined,
                    undefined,
                    [
                            "Numbers ending in 0 are divisible by 10",
                            "Count multiples of 10 in the given range",
                            "The problem simplifies to counting numbers where n % 10 == 0"
                    ],
                    "990",
                    AnswerType.NUMBER
                ),
                new ChallengeItem(
                    "digit-cube-sum",
                    "Digit Cube Sum",
                    "Sum the cubes of a number's digits.\nFor 123: 1³+2³+3³ = 1+8+27 = 36.\nFor 9: 9³ = 729. For 100: 1³+0³+0³ = 1.",
                    "Count numbers with small digit cube sums",
                    "How many three-digit numbers have a digit cube sum less than 100?",
                    [TAGS.EASY],
                    undefined,
                    undefined,
                    [
                            "Calculate the cube of each digit and sum them",
                            "Remember that 0³ = 0, 1³ = 1, 2³ = 8, 3³ = 27, etc.",
                            "Numbers with small digits will have smaller cube sums"
                    ],
                    "85",
                    AnswerType.NUMBER
                ),
            new ChallengeItem(
                "cubic-digits",
                "Cubic Digits",
                "A 'cubic digit' in a number is any digit that equals the cube of another digit (0,1,8 since 0³=0, 1³=1, 2³=8).\nThe number 1828 has three cubic digits. 2345 has no cubic digits.",
                "Find numbers with exactly two cubic digits",
                "Find the sum of all four-digit numbers that contain exactly two cubic digits.",
                [TAGS.MEDIUM],
                undefined,
                undefined,
                [
                    "The only cubic digits are 0, 1, and 8",
                    "Count how many times these digits appear in each four-digit number",
                    "Sum only those numbers where the count equals exactly 2"
                ],
                "11752020",
                AnswerType.NUMBER
            ),
            new ChallengeItem(
                "range-product",
                "Range Product",
                "The 'range' of a number's digits is the difference between the largest and smallest digit.\nFor 5281: max=8, min=1, range=8-1=7. For 777: range=7-7=0.",
                "Product of numbers with specific digit range",
                "Find the product of all two-digit numbers that have a digit range of exactly 5.",
                [TAGS.EASY],
                undefined,
                undefined,
                [
                    "For two-digit numbers, find the max and min of the two digits",
                    "The range is max - min",
                    "Be careful with large products - they can overflow"
                ],
                "1378166551372800",
                AnswerType.NUMBER
            ),
            new ChallengeItem(
                "lucky-seven-position",
                "Lucky Seven Position",
                "A number has a 'lucky seven' if it contains the digit 7.\nThe numbers 17, 71, 777, and 1357 all have lucky sevens.\nThe number 12389 does not.",
                "Count numbers NOT containing digit 7",
                "How many integers from 1 to 100000 do NOT contain the digit 7?",
                [TAGS.EASY],
                undefined,
                undefined,
                [
                    "Check each digit of the number to see if it's a 7",
                    "If any digit is 7, the number has a lucky seven",
                    "Count only those without any 7s"
                ],
                "59049",
                AnswerType.NUMBER
            ),
            new ChallengeItem(
                "perfect-power-check",
                "Perfect Power Check",
                "A perfect power is a number that can be expressed as a^b where a>0 and b>1.\nExamples: 4=2², 8=2³, 9=3², 16=2⁴ or 4², 27=3³.\nThe number 1 is considered a perfect power.",
                "Count perfect powers (numbers expressible as a^b)",
                "How many perfect powers are there less than 50000?",
                [TAGS.MEDIUM],
                undefined,
                undefined,
                [
                    "Try all possible bases from 2 up to sqrt(50000)",
                    "For each base, generate powers until they exceed 50000",
                    "Use a Set to avoid counting duplicates (like 16 = 2⁴ = 4²)"
                ],
                "262",
                AnswerType.NUMBER
            ),
                new ChallengeItem(
                    "digit-gap",
                    "Digit Gap",
                    "The 'digit gap' of a two-digit number is the absolute difference between its digits.\nFor 73: |7-3|=4. For 55: |5-5|=0. For 18: |1-8|=7.",
                    "Sum two-digit numbers with specific digit difference",
                    "Find the sum of all two-digit numbers with a digit gap of exactly 6.",
                    [TAGS.EASY],
                    undefined,
                    undefined,
                    [
                            "Extract tens and ones digits, then find their absolute difference",
                            "Numbers with gap 6: 17, 28, 39, 60, 71, 82, 93",
                            "Notice the pattern in these numbers"
                    ],
                    "390",
                    AnswerType.NUMBER
                ),
            new ChallengeItem(
                "quarter-century",
                "Quarter Century",
                "A 'quarter century' number is one that's divisible by 25.\nThese are: 25, 50, 75, 100, 125, 150, etc.\nThey end in 00, 25, 50, or 75.",
                "Sum digit sums of multiples of 25",
                "Find the sum of the digit sums of all quarter century numbers less than 100000.",
                [TAGS.MEDIUM],
                undefined,
                undefined,
                [
                    "Generate multiples of 25: 25, 50, 75, 100, ...",
                    "For each multiple, calculate the sum of its digits",
                    "Add all these digit sums together"
                ],
                "78000",
                AnswerType.NUMBER
            ),
            new ChallengeItem(
                "sandwich-numbers",
                "Sandwich Numbers",
                "A three-digit 'sandwich number' has its middle digit equal to the sum of its outer digits.\nExample: 132 (1+2=3), 264 (2+4=6), 990 (9+0=9).\nBut not 234 since 2+4≠3.",
                "Three-digit numbers where middle equals sum of outer digits",
                "How many three-digit sandwich numbers exist?",
                [TAGS.EASY],
                undefined,
                undefined,
                [
                    "Extract the three digits: hundreds, tens, and ones",
                    "Check if tens digit equals hundreds + ones",
                    "The middle digit can't exceed 9, so the sum of outer digits must be ≤ 9"
                ],
                "45",
                AnswerType.NUMBER
            ),
            new ChallengeItem(
                "binary-ones-position",
                "Binary Ones Position",
                "In binary, 13 is 1101. The positions of 1s (counting from right, starting at 0) are 0, 2, and 3.\nThe sum of these positions is 0+2+3=5.",
                "Sum positions of 1s in binary representations",
                "Find the sum of all position sums for the binary representations of integers from 1 to 1000.",
                [TAGS.EASY],
                undefined,
                undefined,
                [
                    "Use bit manipulation: check each bit position with (n >> i) & 1",
                    "Sum the positions where bits are 1",
                    "Position counting starts at 0 from the rightmost bit"
                ],
                "22090",
                AnswerType.NUMBER
            ),
            new ChallengeItem(
                "alternating-sum",
                "Alternating Sum",
                "The alternating sum of a number's digits alternates between addition and subtraction.\nFor 12345: 1-2+3-4+5 = 3. For 789: 7-8+9 = 8.",
                "Find numbers with alternating digit sum of zero",
                "Find the sum of all positive integers less than 10000 that have an alternating sum of exactly zero.",
                [TAGS.MEDIUM],
                undefined,
                undefined,
                [
                    "Start with the leftmost digit as positive, then alternate signs",
                    "Keep track of whether you're adding or subtracting each digit",
                    "Numbers like 11, 1001, 1221 have alternating sum of 0"
                ],
                "3349665",
                AnswerType.NUMBER
            ),
            new ChallengeItem(
                "century-numbers",
                "Century Numbers",
                "A 'century number' is a multiple of 100: 100, 200, 300, etc.\nThese all end in 00.",
                "Sum digits in all multiples of 100",
                "Find the sum of all digits in all century numbers from 100 to 50000.",
                [TAGS.EASY],
                undefined,
                undefined,
                [
                    "Century numbers: 100, 200, 300, ..., 50000",
                    "Sum the digits of each century number",
                    "100 has digit sum 1, 200 has digit sum 2, etc."
                ],
                "5505",
                AnswerType.NUMBER
            ),
            new ChallengeItem(
                "balanced-number",
                "Balanced Number",
                "A number is 'balanced' if the sum of digits in odd positions equals the sum of digits in even positions (positions counted from left, starting at 1).\nFor 1342: positions 1,3 have digits 1,4 (sum=5), positions 2,4 have digits 3,2 (sum=5), so it's balanced.",
                "Count numbers with equal odd and even position sums",
                "How many four-digit numbers are balanced?",
                [TAGS.MEDIUM],
                undefined,
                undefined,
                [
                    "For abcd: odd positions are a,c and even positions are b,d",
                    "Need a + c = b + d",
                    "Count all four-digit numbers satisfying this condition"
                ],
                "615",
                AnswerType.NUMBER
            ),
                new ChallengeItem(
                    "nine-remainder",
                    "Nine Remainder",
                    "When dividing by 9, the remainder equals the digital root (sum digits repeatedly until single digit).\nFor 38: 3+8=11, 1+1=2, so 38 mod 9 = 2. For 45: 4+5=9, so 45 mod 9 = 0.",
                    "Count numbers with remainder 7 when divided by 9",
                    "How many integers from 1 to 50000 have a remainder of 7 when divided by 9?",
                    [TAGS.EASY],
                    undefined,
                    undefined,
                    [
                            "Use the modulo operator: n % 9",
                            "Numbers with remainder 7: 7, 16, 25, 34, ...",
                            "This forms an arithmetic sequence with difference 9"
                    ],
                    "5555",
                    AnswerType.NUMBER
                ),
            new ChallengeItem(
                "square-sandwich",
                "Square Sandwich",
                "A three-digit number is a 'square sandwich' if its middle digit is the square of one of its outer digits.\nExamples: 141 (4=2²), 191 (9=3²), 242 (4=2²).\n",
                "Sum numbers where middle digit is square of outer digit",
                "Find the sum of all three-digit square sandwich numbers.",
                [TAGS.MEDIUM],
                undefined,
                undefined,
                [
                    "Check if middle digit equals first² or last²",
                    "Possible squares for single digits: 0,1,4,9",
                    "141, 191, 242, 343, etc. are square sandwiches"
                ],
                "26103",
                AnswerType.NUMBER
            ),
            new ChallengeItem(
                "lucky-thirteen",
                "Lucky Thirteen",
                "A number is 'lucky thirteen' if the sum of its digits equals 13.\nExamples: 49 (4+9=13), 175 (1+7+5=13), 2236 (2+2+3+6=13).\n",
                "Count numbers with digit sum equal to 13",
                "How many positive integers less than 10000 are lucky thirteen numbers?",
                [TAGS.EASY],
                undefined,
                undefined,
                [
                    "Calculate digit sum for each number 1 to 9999",
                    "Count those with digit sum exactly 13",
                    "Examples: 49, 58, 67, 76, 85, 94, 139, 148..."
                ],
                "480",
                AnswerType.NUMBER
            ),
            new ChallengeItem(
                "zigzag-pattern",
                "Zigzag Pattern",
                "A number has a 'zigzag pattern' if digits alternately increase and decrease (or decrease and increase).\nExamples: 132 (1<3>2), 857 (8>5<7). But not: 123 (only increases) or 111 (no change).",
                "Count numbers with alternating increase/decrease",
                "How many three-digit numbers have a zigzag pattern?",
                [TAGS.MEDIUM],
                undefined,
                undefined,
                [
                    "For abc: either a<b>c or a>b<c",
                    "All three digits must be different",
                    "Check both up-down and down-up patterns"
                ],
                "525",
                AnswerType.NUMBER
            ),
            new ChallengeItem(
                "double-double",
                "Double Double",
                "A four-digit number is a 'double double' if it consists of two repeated two-digit sequences.\nExamples: 1212, 4545, 9999.\nThe pattern is ABAB where A and B are digits.",
                "Sum four-digit numbers with ABAB pattern",
                "Find the sum of all four-digit double double numbers.",
                [TAGS.MEDIUM],
                undefined,
                undefined,
                [
                    "Pattern is ABAB where A and B are digits 0-9",
                    "Number equals 1000A + 100B + 10A + B = 1010A + 101B",
                    "Make sure the result is a four-digit number"
                ],
                "495405",
                AnswerType.NUMBER
            ),
            new ChallengeItem(
                "cube-root-digit",
                "Cube Root Digit",
                "A 'cube root digit' is a single digit whose cube root is also a single digit integer.\nOnly 0, 1, and 8 qualify (∛0=0, ∛1=1, ∛8=2).\nCount how many of these digits appear in a number.",
                "Sum numbers with exactly one special digit",
                "Find the sum of all four-digit numbers that contain exactly one cube root digit.",
                [TAGS.MEDIUM],
                undefined,
                undefined,
                [
                    "Cube root digits are 0, 1, and 8",
                    "Count occurrences of these digits in each four-digit number",
                    "Sum only those with exactly one occurrence"
                ],
                "20872089",
                AnswerType.NUMBER
            ),
            new ChallengeItem(
                "fifteen-factor",
                "Fifteen Factor",
                "The 'fifteen factor' of a number counts how many times 15 divides it evenly.\nFor 225: 225÷15=15, 15÷15=1, so fifteen factor is 2. For 14: fifteen factor is 0.",
                "Count how many times 15 divides into numbers",
                "Find the sum of all fifteen factors for integers from 1 to 30000.",
                [TAGS.MEDIUM],
                undefined,
                undefined,
                [
                    "Keep dividing by 15 until no longer divisible",
                    "Count the number of divisions possible",
                    "15 = 3×5, so need both factors"
                ],
                "2141",
                AnswerType.NUMBER
            ),
            new ChallengeItem(
                "neighbor-sum",
                "Neighbor Sum",
                "For each digit in a number, sum it with its neighbors.\nFor 1234: 1+2=3, 1+2+3=6, 2+3+4=9, 3+4=7.\nThe 'neighbor sum total' is 3+6+9+7=25.",
                "Sum based on adjacent digit sums",
                "Find the sum of all neighbor sum totals for integers from 100 to 999.",
                [TAGS.MEDIUM],
                undefined,
                undefined,
                [
                    "For each digit, add it to its adjacent digits",
                    "First and last digits have only one neighbor",
                    "Middle digits have two neighbors"
                ],
                "29250",
                AnswerType.NUMBER
            ),
            new ChallengeItem(
                "power-ending",
                "Power Ending",
                "A number has a 'power ending' if its last two digits form a power of 2: 01, 02, 04, 08, 16, 32, 64.\nExamples: 116, 432, 5064 all have power endings.",
                "Count numbers ending in powers of 2",
                "How many integers from 100 to 99999 have power endings?",
                [TAGS.MEDIUM],
                undefined,
                undefined,
                [
                    "Powers of 2 less than 100: 1, 2, 4, 8, 16, 32, 64",
                    "Check if last two digits (n % 100) match any of these",
                    "Count all numbers in range with these endings"
                ],
                "6993",
                AnswerType.NUMBER
            ),
            new ChallengeItem(
                "triple-digit",
                "Triple Digit",
                "A number contains a 'triple digit' if any digit appears exactly 3 times.\nExamples: 1113 (three 1s), 2322232 (three 3s). But 1111 doesn't count (four 1s, not three).",
                "Count numbers with exactly three occurrences of a digit",
                "How many positive integers less than 100000 contain at least one triple digit?",
                [TAGS.MEDIUM],
                undefined,
                undefined,
                [
                    "Count occurrences of each digit (0-9) in the number",
                    "Check if any digit appears exactly 3 times",
                    "Use an array or object to track digit counts"
                ],
                "7623",
                AnswerType.NUMBER
            ),
            new ChallengeItem(
                "mirror-sum",
                "Mirror Sum",
                "The 'mirror sum' of a number is the sum of the number and its reverse.\nFor 123: 123+321=444. For 89: 89+98=187.\nSingle digits like 5: 5+5=10.",
                "Count numbers whose mirror sum is divisible by 11",
                "How many positive integers less than 1000 have a mirror sum that is divisible by 11?",
                [TAGS.MEDIUM],
                undefined,
                undefined,
                [
                    "First reverse the number, then add it to the original",
                    "Check if the sum is divisible by 11 using modulo",
                    "To reverse: build it digit by digit or convert to string"
                ],
                "171",
                AnswerType.NUMBER
            ),
            new ChallengeItem(
                "peak-digit",
                "Peak Digit",
                "A 'peak digit' in a number is one that's larger than both its neighbors (or larger than its single neighbor for first/last digits).\nIn 13542, the peaks are 5 and 2. In 12321, only 3 is a peak.",
                "Sum three-digit numbers with exactly one peak",
                "Find the sum of all three-digit numbers that have exactly one peak digit.",
                [TAGS.MEDIUM],
                undefined,
                undefined,
                [
                    "A digit is a peak if it's greater than all adjacent digits",
                    "First and last digits only need to be greater than one neighbor",
                    "Count peaks carefully - you need exactly one"
                ],
                "266850",
                AnswerType.NUMBER
            ),
            new ChallengeItem(
                "adjacent-product",
                "Adjacent Product",
                "The 'adjacent products' of a number are products of each pair of adjacent digits.\nFor 234: 2×3=6 and 3×4=12, so products are 6,12.\nFor 1111: all products are 1.",
                "Sum numbers where all adjacent digit products equal 12",
                "Find the sum of all three-digit numbers where all adjacent products equal 12.",
                [TAGS.MEDIUM],
                undefined,
                undefined,
                [
                    "For a three-digit number abc, check if a×b = 12 AND b×c = 12",
                    "If b appears in both products, what values can b have?",
                    "Valid combinations: 262, 343, 434, 626"
                ],
                "1665",
                AnswerType.NUMBER
            ),
                new ChallengeItem(
                    "middle-digit-sum",
                    "Middle Digit Sum",
                    "For odd-length numbers, the middle digit is clear: 12345 has middle digit 3.\nFor even-length numbers, sum the two middle digits: 1234 has middle sum 2+3=5.\nSingle digits count as their own middle.",
                    "Sum of middle digits or middle pairs",
                    "Find the sum of all middle digit values (or middle sums) for integers from 1 to 9999.",
                    [TAGS.MEDIUM],
                    undefined,
                    undefined,
                    [
                            "Determine if the number has odd or even length",
                            "For odd length, find the middle index: Math.floor(length/2)",
                            "For even length, sum the two middle digits"
                    ],
                    "85950",
                    AnswerType.NUMBER
                ),
                new ChallengeItem(
                    "decreasing-run-length",
                    "Decreasing Run Length",
                    "A 'decreasing run' is a sequence of adjacent digits where each is less than the previous.\nIn 8531, '853' is a decreasing run of length 3.\nIn 9876543210, the entire number is a decreasing run of length 10.",
                    "Sum of three-digit numbers with all decreasing digits",
                    "Find the sum of all three-digit numbers that form a complete decreasing run (all three digits decrease).",
                    [TAGS.MEDIUM],
                    undefined,
                    undefined,
                    [
                            "For a three-digit number abc, check if a > b > c",
                            "Examples: 321, 421, 531, 432, etc.",
                            "All three digits must be different"
                    ],
                    "92610",
                    AnswerType.NUMBER
                ),
            new ChallengeItem(
                "prime-factor-frequency",
                "Prime Factor Frequency",
                "The prime factorization of 720 is 2^4 × 3^2 × 5^1. The most frequent prime factor is 2 (appearing 4 times). For 30 = 2×3×5, all primes appear once, so we take the smallest: 2.",
                "Find the most frequent prime factor for each number",
                "Find the sum of the most frequent prime factors for all integers from 2 to 5000. If there's a tie, use the smallest prime.",
                [TAGS.HARD],
                undefined,
                undefined,
                [
                    "First find the prime factorization of each number",
                    "Count the frequency of each prime factor",
                    "When there's a tie in frequency, choose the smallest prime"
                ],
                "1571004",
                AnswerType.NUMBER
            ),
            new ChallengeItem(
                "palindromic-sum-chains",
                "Palindromic Sum Chains",
                "Take 89, reverse it to get 98, add: 89+98=187. Reverse 187 to get 781, add: 187+781=968. Continue: 968+869=1837, 1837+7381=9218, 9218+8129=17347, 17347+74371=91718, 91718+81719=173437, which is palindromic. This took 7 iterations.",
                "Count numbers that become palindromic through reverse-and-add",
                "How many numbers below 10000 become palindromic within exactly 10 iterations using this reverse-and-add process?",
                [TAGS.HARD],
                undefined,
                undefined,
                [
                    "Implement the reverse-and-add process carefully",
                    "Check for palindromes after each iteration",
                    "Count only those that become palindromic on exactly the 10th iteration"
                ],
                "13",
                AnswerType.NUMBER
            ),
            new ChallengeItem(
                "prime-gap-products",
                "Prime Gap Products",
                "Prime gaps are differences between consecutive primes. The gaps starting from 2 are: 1(3-2), 2(5-3), 2(7-5), 4(11-7), 2(13-11)... The product of the first 5 gaps is 1×2×2×4×2 = 32.",
                "Calculate product of unique prime gaps",
                "Find the product of all unique prime gaps for primes less than 50000, modulo 1,000,007.",
                [TAGS.HARD],
                undefined,
                undefined,
                [
                    "Generate all primes less than 50000 using a sieve",
                    "Calculate gaps between consecutive primes",
                    "Use a Set to track unique gaps, then multiply them with modular arithmetic"
                ],
                "932089",
                AnswerType.NUMBER
            ),
            new ChallengeItem(
                "circular-prime-count",
                "Circular Prime Count",
                "A circular prime remains prime through all rotations of its digits. 197 is circular: 197, 971, and 719 are all prime. But 19 is not circular: while 19 and 91 exist, 91 = 7×13.",
                "Count primes that remain prime through digit rotation",
                "How many circular primes are there below 1,000,000?",
                [TAGS.HARD],
                undefined,
                undefined,
                [
                    "Generate all rotations of a number's digits",
                    "Check if all rotations are prime",
                    "Consider optimizations: numbers with even digits can't be circular primes"
                ],
                "55",
                AnswerType.NUMBER
            ),
            new ChallengeItem(
                "digit-power-persistence",
                "Digit Power Persistence",
                "Take a number, raise each digit to the power of the number of digits, and sum. 89: 8² + 9² = 145. Then 1³ + 4³ + 5³ = 190. Continue until reaching a cycle. 89 eventually cycles at 89 again, taking 7 steps.",
                "Find numbers that reach a specific cycle",
                "How many starting numbers below 10000 reach the cycle containing 89?",
                [TAGS.HARD],
                undefined,
                undefined,
                [
                    "For each digit d in an n-digit number, compute d^n",
                    "Keep applying the transformation until you hit a cycle",
                    "Track which numbers lead to 89 vs other cycles (like 1)"
                ],
                "1452",
                AnswerType.NUMBER
            ),
            new ChallengeItem(
                "triangular-pentagonal",
                "Triangular Pentagonal",
                "Triangular numbers: T(n) = n(n+1)/2 gives 1,3,6,10,15... Pentagonal numbers: P(n) = n(3n-1)/2 gives 1,5,12,22,35... The number 1 is both triangular and pentagonal.",
                "Find numbers that are both triangular and pentagonal",
                "Find the sum of all numbers less than 10,000,000 that are both triangular and pentagonal.",
                [TAGS.HARD],
                undefined,
                undefined,
                [
                    "Use the formulas to check if a number is triangular or pentagonal",
                    "For triangular: solve n(n+1)/2 = x for n",
                    "For pentagonal: solve n(3n-1)/2 = x for n"
                ],
                "7947242",
                AnswerType.NUMBER
            )
        ]
    ),
    new Challenge(
        "algorithmic-challenges",
        "Algorithmic Thinking Challenges",
        "Practice fundamental algorithms and data structures",
        AlgorithmChallenge,
        "algorithmicChallenges",
        false,
        false,
        [
            // EASY PROBLEMS
            new ChallengeItem(
                "array-sum",
                "Simple Array Sum",
                "Add up all numbers in an array.",
                "Find the sum of array elements",
                "Calculate the sum of: [15, 23, 42, 8, 16, 4, 91, 35]",
                [TAGS.EASY],
                "[1, 2, 3, 4, 5]",
                "15",
                [
                    "Start with a variable to hold the total sum, initialized to 0",
                    "Loop through each element in the array",
                    "Add each element to your running total"
                ],
                "234",
                AnswerType.NUMBER,
                "Starting with 0, we add each number: 0+1=1, 1+2=3, 3+3=6, 6+4=10, 10+5=15"
            ),
            new ChallengeItem(
                "count-vowels",
                "Vowel Counter",
                "Count how many vowels (a,e,i,o,u) appear in a text. Case doesn't matter.",
                "Count vowels in a string",
                "How many vowels in: 'Programming is awesome and fun!'",
                [TAGS.EASY],
                "'Hello World'",
                "3",
                [
                    "Convert the string to lowercase to handle case-insensitivity",
                    "Define what vowels are: a, e, i, o, u",
                    "Check each character to see if it's a vowel"
                ],
                "11",
                AnswerType.NUMBER,
                "'Hello World' contains: e (position 1), o (position 4), o (position 7) = 3 vowels total"
            ),
            new ChallengeItem(
                "alternating-sum",
                "Alternating Add and Subtract",
                "Add first number, subtract second, add third, subtract fourth, and so on.",
                "Calculate alternating sum",
                "Calculate: 12 - 45 + 23 - 67 + 34 - 89 + 11 - 56 + 78",
                [TAGS.EASY],
                "[10, 20, 30, 40]",
                "-20",
                [
                    "Keep track of whether you're adding or subtracting (use a sign variable)",
                    "Start with the first element as positive",
                    "Alternate the sign for each subsequent element"
                ],
                "-99",
                AnswerType.NUMBER,
                "Start with +10, then -20 gives -10, then +30 gives 20, then -40 gives -20"
            ),
            new ChallengeItem(
                "binary-ones-count",
                "Count Binary Ones",
                "Convert numbers to binary and count all the 1s.",
                "Count 1s in binary representations",
                "Count total 1s in binary form of all numbers from 1 to 15.",
                [TAGS.EASY],
                "Numbers 1 to 7",
                "12",
                [
                    "Convert each number to binary representation",
                    "Count the '1' characters in each binary string",
                    "Sum up all the counts"
                ],
                "32",
                AnswerType.NUMBER,
                "1=1(1), 2=10(1), 3=11(2), 4=100(1), 5=101(2), 6=110(2), 7=111(3). Total: 1+1+2+1+2+2+3 = 12 ones"
            ),
            new ChallengeItem(
                "string-compression",
                "Compress Repeated Characters",
                "Replace repeated characters with character + count. Example: 'aaa' becomes 'a3'.",
                "Find compressed string length",
                "What's the length of 'aaabbbbbccdddeeeee' after compression?",
                [TAGS.EASY],
                "'aabbcc'",
                "6",
                [
                    "Keep track of the current character and its count",
                    "When you encounter a different character, append the previous character and count",
                    "Don't forget to handle the last group of characters"
                ],
                "10",
                AnswerType.NUMBER,
                "'aabbcc' has 2 a's, 2 b's, 2 c's. Compressed: 'a2b2c2' which has length 6 (a,2,b,2,c,2)"
            ),
            // EASY-MEDIUM MIX
            new ChallengeItem(
                "find-range",
                "Array Range",
                "Find the difference between the largest and smallest numbers.",
                "Calculate max minus min",
                "Find the range of: [45, 12, 89, 23, 67, 34, 98, 11, 56]",
                [TAGS.MEDIUM],
                "[5, 2, 8, 1, 9]",
                "8",
                [
                    "Initialize max and min with the first element",
                    "Compare each element with current max and min",
                    "The range is max - min"
                ],
                "87",
                AnswerType.NUMBER,
                "Scanning array: max=9 (largest), min=1 (smallest). Range = 9 - 1 = 8"
            ),
            new ChallengeItem(
                "unique-sum",
                "Sum Without Duplicates",
                "Remove duplicate numbers, then sum what's left.",
                "Sum unique elements only",
                "Sum unique values in: [4, 5, 4, 3, 5, 6, 3, 2, 6, 7, 8, 7]",
                [TAGS.MEDIUM],
                "[1, 2, 2, 3, 3, 3]",
                "6",
                [
                    "Use a Set or similar data structure to track unique values",
                    "Add each unique value only once",
                    "Sum all the unique values"
                ],
                "35",
                AnswerType.NUMBER,
                "Array has duplicates: 1 appears once, 2 appears twice, 3 appears thrice. Unique values: {1, 2, 3}. Sum: 1+2+3 = 6"
            ),
            new ChallengeItem(
                "substring-values",
                "Numeric Substring Sum",
                "For a string of digits, find all possible substrings and sum their numeric values.",
                "Sum all numeric substrings",
                "Sum all substrings of '123' as numbers.",
                [TAGS.MEDIUM],
                "'12'",
                "15",
                [
                    "Generate all possible substrings (start from each position, extend to each subsequent position)",
                    "Convert each substring to a number",
                    "Sum all the numeric values"
                ],
                "164",
                AnswerType.NUMBER,
                "Substrings of '12': '1'=1, '2'=2, '12'=12. Total sum: 1+2+12 = 15"
            ),
            // MEDIUM PROBLEMS
            new ChallengeItem(
                "peak-valley-count",
                "Peaks and Valleys",
                "Peak: higher than neighbors. Valley: lower than neighbors. Count both.",
                "Count peaks and valleys",
                "Count peaks and valleys in: [1, 3, 2, 5, 4, 6, 3, 2, 7]",
                [TAGS.MEDIUM],
                "[2, 1, 3, 1, 2]",
                "3",
                [
                    "Skip the first and last elements (they can't be peaks or valleys)",
                    "For each middle element, compare with both neighbors",
                    "Count as peak if greater than both, valley if less than both"
                ],
                "4",
                AnswerType.NUMBER,
                "Array [2,1,3,1,2]: position 1 has value 1 (2>1<3) is a valley, position 2 has value 3 (1<3>1) is a peak, position 3 has value 1 (3>1<2) is a valley. Total: 1 peak + 2 valleys = 3"
            ),
            new ChallengeItem(
                "rotation-max-sum",
                "Best Array Rotation",
                "Rotate array and calculate sum of (position × value). Find maximum.",
                "Find maximum weighted sum",
                "Array [4,3,2,6]. For each rotation, sum (index × value). What's the maximum?",
                [TAGS.MEDIUM],
                "[1, 2, 3]",
                "8",
                [
                    "For each rotation, calculate the weighted sum",
                    "Weighted sum means: element × its position (0-indexed)",
                    "Try all possible rotations and keep track of the maximum"
                ],
                "26",
                AnswerType.NUMBER,
                "Original [1,2,3]: 0×1+1×2+2×3=0+2+6=8. Rotate to [2,3,1]: 0×2+1×3+2×1=0+3+2=5. Rotate to [3,1,2]: 0×3+1×1+2×2=0+1+4=5. Maximum is 8"
            ),
            new ChallengeItem(
                "pattern-matching",
                "Word Pattern Match",
                "Check if words match a pattern where same letters map to same characters throughout.",
                "Count matching words",
                "Pattern 'abb', words ['egg','add','see','too','zoo']. How many match?",
                [TAGS.MEDIUM],
                "Pattern 'ab'",
                "2",
                [
                    "Create a mapping from pattern letters to word characters",
                    "Ensure each pattern letter maps to exactly one unique character",
                    "Check that the mapping is consistent throughout the word"
                ],
                "3",
                AnswerType.NUMBER,
                "Pattern 'ab' means first char differs from second. 'xy' matches (a→x, b→y), 'cd' matches (a→c, b→d), but 'aa' fails (would need a→a and b→a, but b must differ from a)"
            ),
            new ChallengeItem(
                "missing-count",
                "Missing Numbers Count",
                "Given a range and an array, count how many numbers from the range are missing.",
                "Count missing integers",
                "Range 1-20, array has [3,5,7,9,11,13,15,17,19]. How many missing?",
                [TAGS.MEDIUM],
                "Range 1-5, array [2,4]",
                "3",
                [
                    "Create a set of all numbers in the given range",
                    "Remove numbers that appear in the array",
                    "Count remaining numbers"
                ],
                "11",
                AnswerType.NUMBER,
                "Range 1-5 contains {1,2,3,4,5}. Array has {2,4}. Missing numbers: {1,3,5}. Count = 3"
            ),
            // MEDIUM-HARD MIX
            new ChallengeItem(
                "sequence-differences",
                "Difference Sequence Final Value",
                "Keep taking differences between adjacent elements until one number remains.",
                "Find final value after repeated differences",
                "Start with [5, 8, 14, 23, 35]. Apply differences repeatedly. Final value?",
                [TAGS.MEDIUM],
                "[1, 3, 6, 10]",
                "1",
                [
                    "Calculate differences between each adjacent pair",
                    "This creates a new sequence with one less element",
                    "Repeat until only one value remains"
                ],
                "3",
                AnswerType.NUMBER,
                "[1,3,6,10] → differences [2,3,4] → differences [1,1] → difference [0]. But we want the last remaining value, which is 1 from [1,1]"
            ),
            // HARD PROBLEMS
            new ChallengeItem(
                "digit-sum-growth",
                "Digit Sum Growth",
                "Start with a number, sum its digits, add to original. Repeat. Find value after steps.",
                "Track number growth through digit sums",
                "Start with 47. Add digit sum 5 times. Final value?",
                [TAGS.HARD],
                "Start: 12, steps: 3",
                "21",
                [
                    "Calculate the digit sum of the current number",
                    "Add the digit sum to the current number",
                    "Repeat for the specified number of steps"
                ],
                "92",
                AnswerType.NUMBER,
                "12→digit sum 3→15 (step 1), 15→digit sum 6→21 (step 2), 21→digit sum 3→24 (step 3). Final: 21"
            ),
            new ChallengeItem(
                "equal-partition",
                "Equal Sum Partition Point",
                "Find where to split array so left sum equals right sum. Return the index.",
                "Find split point for equal sums",
                "Find partition index for: [1, 2, 3, 4, 3, 2, 1]",
                [TAGS.HARD],
                "[2, 1, 1, 2]",
                "2",
                [
                    "Calculate the total sum first",
                    "Keep a running sum while iterating",
                    "Check if left sum equals right sum at each position"
                ],
                "4",
                AnswerType.NUMBER,
                "Array [2,1,1,2]: At index 2, left sum is 2+1=3, right sum is 2 (just the last element), but these aren't equal. Check each position for equal sums"
            ),
            new ChallengeItem(
                "self-describing",
                "Self-Describing Powers",
                "Find numbers where digit count equals the number itself when squared or cubed.",
                "Count self-describing powers",
                "How many numbers n < 100 have digit_count(n²) = n or digit_count(n³) = n?",
                [TAGS.HARD],
                "Range: 1-20",
                "2",
                [
                    "For each number, calculate its square and cube",
                    "Count digits in the results",
                    "Check if digit count equals the original number"
                ],
                "6",
                AnswerType.NUMBER,
                "Check each n: n=7 has 7²=49 (2 digits)≠7, 7³=343 (3 digits)≠7. n=18 has 18²=324 (3 digits)≠18, 18³=5832 (4 digits)≠18. Keep checking..."
            ),
            new ChallengeItem(
                "cyclic-shift-match",
                "Cyclic String Shifts",
                "Count strings that become the same after some cyclic shift.",
                "Count shift-equivalent strings",
                "Strings: ['abc','bca','xyz','cab','def']. How many groups of shift-equivalent?",
                [TAGS.HARD],
                "['ab','ba','aa']",
                "2",
                [
                    "Generate all cyclic shifts of each string",
                    "Group strings that have matching shifts",
                    "Count the number of unique groups"
                ],
                "2",
                AnswerType.NUMBER,
                "'ab' shifts to 'ba', 'ba' shifts to 'ab' (same group). 'aa' shifts to 'aa' (own group). Total: 2 groups"
            ),
            new ChallengeItem(
                "matrix-diagonal-sum",
                "Matrix Diagonal Product",
                "Multiply main diagonal elements, then anti-diagonal elements. Return their sum.",
                "Sum products of both diagonals",
                "3×3 matrix [[2,1,3],[4,5,6],[7,8,9]]. Sum of diagonal products?",
                [TAGS.HARD],
                "[[1,2],[3,4]]",
                "10",
                [
                    "Main diagonal: elements where row index equals column index",
                    "Anti-diagonal: elements where row + column = size - 1",
                    "Calculate products separately then sum"
                ],
                "210",
                AnswerType.NUMBER,
                "2×2 matrix: main diagonal is 1×4=4, anti-diagonal is 2×3=6. Sum: 4+6=10"
            ),
            new ChallengeItem(
                "spiral-sum",
                "Spiral Matrix Sum",
                "Traverse matrix in spiral order. Sum elements at positions divisible by 3.",
                "Sum specific spiral positions",
                "3×3 matrix [[1,2,3],[4,5,6],[7,8,9]]. Sum positions 0,3,6,9...",
                [TAGS.HARD],
                "[[1,2],[3,4]]",
                "4",
                [
                    "Traverse in spiral order: right, down, left, up, repeat",
                    "Keep track of position count (0-indexed)",
                    "Sum elements at positions divisible by 3"
                ],
                "25",
                AnswerType.NUMBER,
                "Spiral order: 1,2,4,3. Positions divisible by 3: position 0 (value 1) and position 3 (value 3). Sum: 1+3=4"
            )
        ]
    )
] 